<div
  class="flex min-h-screen flex-col items-center justify-center gap-6 bg-gray-100"
  *transloco="let t; read: 'auth.invitation.invalidInvitation'"
>
  <img src="assets/images/logo/taxtimer-logo.svg" alt="Taxtimer Logo" />

  <div class="flex h-full w-[640px] flex-col gap-8 rounded-[5px] bg-white px-12 pt-10 pb-14">
    <h2 class="text-primary text-center">{{ t('title') }}</h2>
    <div class="flex flex-col items-center">
      <p class="text-large-bold mb-3 text-center">{{ t('contentPartOne') }}</p>
      <p class="text-large-regular mb-3 text-center">{{ t('contentPartTwo') }}</p>
      <button type="button" class="!text-small-bold text-primary hover:text-primary-dark w-fit text-left">
        {{ t('link.requestNewInvitationLink') }}
      </button>
    </div>

    <button routerLink="/auth/login" type="button" class="btn btn-primary justify-center">{{ t('button.backToLogin') }}</button>
  </div>
  <app-legal-links-container></app-legal-links-container>
</div>
